/**
 * Act2Screen — 第二幕主屏幕
 */
import React, { useEffect, useRef } from 'react';
import { Act2TopBar } from './Act2TopBar';
import { Act2ChatArea } from './Act2ChatArea';
import { Act2BottomPanel } from './Act2BottomPanel';
import { useAct2Store } from '../../stores/act2Store';
import { useRootStore } from '../../stores/rootStore';
import { useAct2Loop } from '../../hooks/useAct2Loop';
import { ACT2_MAX_SWAPS } from '@shared/constants/gameBalance';
import type { Act2Card } from '@shared/types/cards';

interface Act2ScreenProps {
  onSettingsClick?: () => void;
}

export const Act2Screen: React.FC<Act2ScreenProps> = ({ onSettingsClick }) => {
  const root = useRootStore();
  const act2 = useAct2Store();
  const { playCard, skip, startFirstRound, phase } = useAct2Loop();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (!hasStarted.current && act2.phase === 'WAITING' && act2.messages.length === 0) {
      hasStarted.current = true;
      startFirstRound();
    }
  }, [act2.phase, act2.messages.length, startFirstRound]);

  if (!root.protagonistA || !root.protagonistB) return null;

  const handlePlayCard = (card: Act2Card) => {
    playCard(card);
  };

  return (
    <div className="h-screen flex flex-col bg-cream">
      <Act2TopBar
        round={act2.round}
        topicStage={act2.topicStage}
        metricsA={act2.metricsA}
        metricsB={act2.metricsB}
        nameA={root.protagonistA.name}
        nameB={root.protagonistB.name}
        scene={act2.scene}
        onSettingsClick={onSettingsClick}
      />

      <Act2ChatArea
        messages={act2.messages}
        protagonistA={root.protagonistA}
        protagonistB={root.protagonistB}
        isTyping={act2.isTyping}
        typingSpeaker={act2.typingSpeaker}
        streamingText={act2.streamingText}
        streamingAgentName={act2.streamingAgentName}
        streamingAgentRole={act2.streamingAgentRole}
        currentSpeaker={act2.currentSpeaker}
        isCardNarrating={act2.isCardNarrating}
        cardNarrativeText={act2.cardNarrativeText}
      />

      <Act2BottomPanel
        hand={act2.hand}
        deckSize={act2.deck.length}
        phase={phase}
        swapCount={act2.swapCount}
        maxSwaps={ACT2_MAX_SWAPS}
        onPlayCard={handlePlayCard}
        onSkip={skip}
      />
    </div>
  );
};

export default Act2Screen;
